export default __webpack_public_path__ + "static/media/illustration-study-3-m@3x.d580d0bf.webp";